import { render, staticRenderFns } from "./SuperBomComponentAutoList.vue?vue&type=template&id=5213f7b7&scoped=true"
import script from "./SuperBomComponentAutoList.vue?vue&type=script&lang=js"
export * from "./SuperBomComponentAutoList.vue?vue&type=script&lang=js"
import style0 from "./SuperBomComponentAutoList.vue?vue&type=style&index=0&id=5213f7b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5213f7b7",
  null
  
)

export default component.exports